var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OUTLINE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 45,
    viewBox: "2 0 60 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26 29 26 38.68 22.38 42.29 23.79 43.71 26 41.51 26 46 28 46 28 41.35 30.38 43.71 31.79 42.29 28 38.53 28 29 26 29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 17 28 17 28 7.49 31.79 3.71 30.38 2.29 28 4.66 28 0 26 0 26 4.49 23.79 2.29 22.38 3.71 26 7.3 26 17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "33.08 22 33.08 24 42.68 24 46.38 27.71 47.79 26.29 45.51 24 50 24 50 22 45.52 22 47.79 19.7 46.38 18.3 42.7 22 33.08 22"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.38 26.3 7.79 27.7 11.47 24 21 24 21 22 11.49 22 7.79 18.29 6.38 19.71 8.66 22 4.08 22 4.08 24 8.65 24 6.38 26.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.12 12.69 15.34 12.67 25.67 23 15.35 33.32 10.12 33.31 10.11 35.31 13.35 35.32 10.11 38.56 11.53 39.97 14.76 36.74 14.77 39.97 16.77 39.97 16.75 34.75 27.09 24.41 37.41 34.74 37.4 39.97 39.4 39.97 39.4 36.73 42.64 39.97 44.05 38.56 40.82 35.33 44.06 35.31 44.05 33.31 38.83 33.33 28.5 23 38.82 12.68 44.05 12.69 44.06 10.69 40.82 10.68 44.05 7.44 42.64 6.03 39.41 9.26 39.4 6.03 37.4 6.03 37.42 11.25 27.09 21.59 16.76 11.26 16.77 6.03 14.77 6.03 14.77 9.27 11.53 6.03 10.11 7.44 13.35 10.68 10.11 10.69 10.12 12.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinter);
export default __webpack_public_path__ + "static/media/winter.c3e22c90faa2e4ffc1187a0560b92f7b.svg";
export { ForwardRef as ReactComponent };